import {$} from "../../core/js/Dom.ts";
import {updateDateFinPlus4An} from "../../core/js/Utils.ts";

document.addEventListener('DOMContentLoaded', function () {
    if(document.body.dataset.url === "homologation_add" || document.body.dataset.url === 'homologation_update') {
        updateNom()
        $('#id_date_debut')?.addEventListener('change', updateDateFin)
    }
})

function updateDateFin(event: DOMEvent<HTMLInputElement>) {
    const date_fin = $<HTMLInputElement>('#id_date_fin')
    const dateDebutInput = event.target
    if(dateDebutInput && date_fin) {
        updateDateFinPlus4An(dateDebutInput,date_fin)
    }
    updateNom()
}

function updateNom() {
    const champNom = $<HTMLInputElement>("#id_nom")
    const objet_demande_homologation = $<HTMLOptionElement>("#id_objet_demande_homologation option[selected]")
    const circuit_fk = $<HTMLOptionElement>("#id_circuit_fk option[selected]")
    const date_debut = $<HTMLInputElement>("#id_date_debut")
    if(champNom && objet_demande_homologation && circuit_fk && date_debut) {
        const date = new Date(date_debut.value)
        champNom.value = `${objet_demande_homologation.innerText.trim()} - ${circuit_fk.innerText.trim()} - ${date.toLocaleDateString('fr-FR')}`
    }
}
